'use strict';

import '../lib/mmenu_old_version/js/mmenu.js';

document.addEventListener( 
		"DOMContentLoaded", () => {
	var $m = $("#mobile_menu").mmenu({
		"extensions": [
			"border-full",
			"theme-white"
		],
		"offCanvas": {
			"position": "left"	//meniu sliding from right side
		},
		"counters": false,
		"slidingSubmenus": false,
	}, {
		selectedClass: "active"
	});
//document.body.removeEventListener('keydown', document.body.mmEventKeydownTabguard[0])
	$(window).bind("pageshow", function (event) {
		if (event.originalEvent.persisted) { //bugfix - iphone safari history state leaves menu open. Close it!
			setTimeout(function () {
				var API = $m.data("mmenu");
				API.close();
			}, 50);
		}
	});
});